/**
 * This is import script.js file
 */
import ActionsDetail from '@/components/actions-detail';
import DayEndClosingImports from './day-end-closing-imports';
import ImportedModal from './imported-modal';
import ImportFile from './import-file';
import moment from 'moment';
import RdFileDownload from '@/components/modal-rd-file-download';
import DatePickerMixin from '@/mixins/datepicker';

export default {
  name: 'Import',
  components: {
    ActionsDetail,
    DayEndClosingImports,
    ImportedModal,
    ImportFile,
    RdFileDownload
  },
  mixins: [DatePickerMixin],
  /**
   * @override
   */
  data() {
    return {
      loading: false,
      selectedFileType: null,
      importDetailsModalId: 'import_details_modal',
      importDetailsData: {},
      fetchUploadInterval: null,
      dayUploads: [],
      inProgress: [],
      fetchingDayUploads: null,
      generatingFileToRD: false,
      from: moment().format('YYYY-MM-DD'),
      until: moment().format('YYYY-MM-DD'),
      scheduledInterveners: 0,
      scheduledAccounts: 0,
      scheduledOperations: 0
    };
  },
  methods: {
    fetchDayUploads(day = moment()) {
      const filter = {
        created_on: [{ gte: day.format('YYYY-MM-DD'), lt: day.add(1, 'day').format('YYYY-MM-DD') }]
      };
      const $filter = btoa(JSON.stringify(filter));
      const cfg = {
        params: {
          $filter
        }
      };
      this.$importService.listUploads(cfg).then(res => {
        // this.$emit('changed', res.data);
        this.dayUploads = res.data.uploads;
      });
    },
    onInProgress(inProgress) {
      this.inProgress = inProgress;
    },
    /**
     * Descarga de fichero IDPAR de RD en el rango indicado
     * @return {*} Promesa
     */
    downloadFile() {
      const operationsFilter = {
        exported: [{ eq: false }]
      };
      const accountsAndIntervenersFilter = {
        // el prefijo 'or' hará que se añada un operador 'OR' entre este filtro y el siguiente
        exported: [{ eq: false }]
      };
      const $accountsAndIntervenersFilter = btoa(JSON.stringify(accountsAndIntervenersFilter));
      const $operationsFilter = btoa(JSON.stringify(operationsFilter));
      return this.$accountsService
        .downloadAllCrmExportFiles({
          params: {
            $export_accounts: true,
            $accounts_filter: $accountsAndIntervenersFilter,
            $export_interveners: true,
            $interveners_filter: $accountsAndIntervenersFilter,
            $export_operations: true,
            $operations_filter: $operationsFilter
          }
        })
        .then(() => this.getScheduled());
    },

    showModal() {
      this.getScheduled().then(() => {
        this.$bvModal.show('bv-modal-example');
      });
    },

    getScheduled() {
      const operationsFilter = {
        exported: [{ eq: false }]
      };
      const accountsAndIntervenersFilter = {
        // el prefijo 'or' hará que se añada un operador 'OR' entre este filtro y el siguiente
        exported: [{ eq: false }]
      };
      const $accountsAndIntervenersFilter = btoa(JSON.stringify(accountsAndIntervenersFilter));
      const $operationsFilter = btoa(JSON.stringify(operationsFilter));
      return this.$accountsService
        .getCrmScheduled({
          params: {
            $export_accounts: true,
            $accounts_filter: $accountsAndIntervenersFilter,
            $export_interveners: true,
            $interveners_filter: $accountsAndIntervenersFilter,
            $export_operations: true,
            $operations_filter: $operationsFilter
          }
        })
        .then(result => {
          try {
            this.scheduledOperations = result.data.operations.length;
          } catch (err) {
            console.warn(err);
            this.scheduledOperations = 0;
          }
          try {
            this.scheduledAccounts = result.data.accounts.length;
          } catch (err) {
            console.warn(err);
            this.scheduledAccounts = 0;
          }
          try {
            this.scheduledInterveners = result.data.interveners.length;
          } catch (err) {
            console.warn(err);
            this.scheduledInterveners = 0;
          }
          return result;
        });
    }
  },
  computed: {
    /**
     * Literal del período seleccionado
     * @return {String} literal
     */
    dates() {
      const format = {
        sameDay: '[hoy]',
        nextDay: '[mañana]',
        nextWeek: 'dddd',
        lastDay: '[ayer]',
        lastWeek: '[el pasado] dddd',
        sameElse: '[el] dddd DD/MM/YYYY'
      };
      if (this.from === this.until) {
        return moment(this.from).calendar(null, format);
      } else {
        let str = '';
        if (this.from) {
          str = `desde ${moment(this.from).calendar(null, format)} `;
        }

        if (this.until) {
          str += `hasta ${moment(this.until).calendar(null, format)}`;
        }
        return str;
      }
    },

    /**
     * Sufijo con rango de fechas
     * @return {String} sufijo
     */
    suffix() {
      let suffix = '';
      if (this.from) {
        suffix += `-${moment(this.from).format('YYYYMMDD')}`;
      }

      if (this.until) {
        suffix += `-${moment(this.until).format('YYYYMMDD')}`;
      }
      return suffix;
    },

    /**
     * Filtro con rango de fechas
     * @return {Array} filtro
     */
    filter() {
      const filter = [];
      if (this.from) {
        filter.push({
          gt: moment(this.from)
            .milliseconds(0)
            .seconds(0)
            .minutes(0)
            .hours(0)
            .toISOString()
        });
      }

      if (this.until) {
        filter.push({
          lt: moment(this.until)
            .milliseconds(999)
            .seconds(59)
            .minutes(59)
            .hours(23)
            .toISOString()
        });
      }
      return filter;
    },

    /**
     * @return {Number} entidades seleccionadas
     */
    scheduled() {
      const s = Number(this.scheduledAccounts) + Number(this.scheduledOperations) + Number(this.scheduledInterveners);

      return isNaN(s) ? 0 : s;
    }
  },
  mounted() {
    this.fetchDayUploads();
    // clearInterval(this.fetchingDayUploads);
    // this.fetchingDayUploads = setInterval(() => {
    //     this.fetchDayUploads();
    // }, 3000);
  },
  beforeDestroy() {
    clearInterval(this.fetchingDayUploads);
  }
};
